import React from 'react';
import {
  Box,
  Paper,
  Typography,
  TextField,
  Button,
  Grid,
  Card,
  CardContent,
  InputAdornment,
  CircularProgress
} from '@mui/material';
import { LinkedIn, Search } from '@mui/icons-material';

/**
 * Import Profile Tab Component
 * Handles LinkedIn URL input and profile data fetching
 */
const ImportProfileTab = ({
  linkedinUrl,
  setLinkedinUrl,
  fetchLinkedInData,
  isLoading
}) => {
  return (
    <Grid container spacing={3}>
      <Grid item xs={12} md={8}>
        <Card>
          <CardContent>
            <Typography variant="h6" gutterBottom>
              Import LinkedIn Profile
            </Typography>
            <Typography variant="body2" color="textSecondary" sx={{ mb: 3 }}>
              Enter a LinkedIn profile URL to automatically import professional information
            </Typography>
            
            <TextField
              fullWidth
              label="LinkedIn Profile URL"
              placeholder="https://www.linkedin.com/in/username"
              value={linkedinUrl}
              onChange={(e) => setLinkedinUrl(e.target.value)}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <LinkedIn color="primary" />
                  </InputAdornment>
                ),
              }}
              sx={{ mb: 3 }}
              onKeyPress={(e) => {
                if (e.key === 'Enter') {
                  fetchLinkedInData();
                }
              }}
            />
            
            <Button
              variant="contained"
              size="large"
              startIcon={isLoading ? <CircularProgress size={20} /> : <Search />}
              onClick={fetchLinkedInData}
              disabled={isLoading || !linkedinUrl.trim()}
              fullWidth
            >
              {isLoading ? 'Loading Profile...' : 'Import Profile'}
            </Button>
          </CardContent>
        </Card>
      </Grid>
      
      <Grid item xs={12} md={4}>
        <Card>
          <CardContent>
            <Typography variant="h6" gutterBottom>
              How it works
            </Typography>
            <Box sx={{ mt: 2 }}>
              <Typography variant="body2" sx={{ mb: 2 }}>
                <strong>1.</strong> Enter a LinkedIn profile URL
              </Typography>
              <Typography variant="body2" sx={{ mb: 2 }}>
                <strong>2.</strong> We'll automatically extract professional information
              </Typography>
              <Typography variant="body2" sx={{ mb: 2 }}>
                <strong>3.</strong> Edit and customize your resume
              </Typography>
              <Typography variant="body2">
                <strong>4.</strong> Export as a professional PDF
              </Typography>
            </Box>
          </CardContent>
        </Card>
        
        <Card sx={{ mt: 2 }}>
          <CardContent>
            <Typography variant="h6" gutterBottom>
              Features
            </Typography>
            <ul style={{ margin: 0, paddingLeft: 20 }}>
              <li>
                <Typography variant="body2">Automatic data extraction</Typography>
              </li>
              <li>
                <Typography variant="body2">5 professional templates</Typography>
              </li>
              <li>
                <Typography variant="body2">Drag & drop editing</Typography>
              </li>
              <li>
                <Typography variant="body2">PDF export</Typography>
              </li>
              <li>
                <Typography variant="body2">Real-time preview</Typography>
              </li>
            </ul>
          </CardContent>
        </Card>
      </Grid>
    </Grid>
  );
};

export default ImportProfileTab;
